export const BUILD_VERSION = '1790209693';
